import React from "react"
import PropTypes from "prop-types"

const Footer = ({ siteDisclaimer, siteFooterLinks }) => (
  <div className="section footer">
    <div className="container">
      <div className="clear-footer--wrapper">
        <ul className="nav-list footer">
          <li className="nav--link footer-link disclaimer">{siteDisclaimer}
          </li>
         {siteFooterLinks.map(
                (linked_items, index) => (
                  <li key={index} className="nav--link footer-link">
                  <a href={linked_items.elements.url.value} target="blank">
                    {linked_items.elements.text.value}
                  </a>
                </li>
                )
              )}
        </ul>
      </div>
    </div>
  </div>
)

Footer.propTypes = {
  siteDisclaimer: PropTypes.string,
  siteFooterLinks: PropTypes.arrayOf(PropTypes.object),
}

export default Footer
